import { useFormikContext } from 'formik';
import {
  Dropdown,
  DropdownItem,
} from '@quicktools/shared-components/components/core/form/Dropdown';

import { ReactComponent as SwitchIcon } from '../../../svgIcons/switch.svg';
import { getCategoryName } from '../../../utils/common/category';
import analytics from '../../../services/analytics';
import TextLabel from '../TextLabel/TextLabel';

import useStyles from './styles';
import { TranslatorDropdownProps, TranslatorFileds } from './types';

function TranslatorDropdown({ from, to, formProps }: TranslatorDropdownProps) {
  const classes = useStyles();
  const { setFieldValue } = useFormikContext();

  const openDropdown = (variant: TranslatorFileds) => {
    analytics.textBoxClick({
      text_box_name: variant.analyticsName,
      category_name: getCategoryName(variant.selectedCategory),
      page_path: window.location.pathname,
    });
  };

  const onIconClick = () => {
    if (!formProps.values[from.name]) {
      setFieldValue(to.name, 'English');
    } else {
      setFieldValue(to.name, formProps.values[from.name]);
    }

    setFieldValue(from.name, formProps.values[to.name]);
  };

  return (
    <div className={classes.root}>
      <div className={classes.group}>
        <TextLabel required={false} htmlFor={from.name} label={from.textLabel} />
        <Dropdown
          onToggle={(open) => open && openDropdown(from)}
          name={from.name}
          svgIconName="collapse-arrow-down-gen"
          className={classes.dropDown}
          buttonClassName={classes.button}
          popoverClassName={classes.popoverClass}
          value={formProps.values[from.name] || 'detect'}
          onChange={(value) => {
            if (value === 'detect') {
              setFieldValue(from.name, '');
              return;
            }
            setFieldValue(from.name, value);
          }}
        >
          {from.dropdownValues.map((item: { title: string; value: string }) => (
            <DropdownItem key={item.value} value={item.value}>
              {item.title}
            </DropdownItem>
          ))}
        </Dropdown>
      </div>
      <SwitchIcon className={classes.icon} onClick={onIconClick} />
      <div className={classes.group}>
        <TextLabel required={false} htmlFor={to.name} label={to.textLabel} />
        <Dropdown
          onToggle={(open) => open && openDropdown(to)}
          name={to.name}
          svgIconName="collapse-arrow-down-gen"
          className={classes.dropDown}
          buttonClassName={classes.button}
          popoverClassName={classes.popoverClass}
          value={formProps.values[to.name]}
          onChange={(value) => {
            setFieldValue(to.name, value);
          }}
        >
          {to.dropdownValues.map((item: { title: string; value: string }) => (
            <DropdownItem key={item.value} value={item.value}>
              {item.title}
            </DropdownItem>
          ))}
        </Dropdown>
      </div>
    </div>
  );
}
export default TranslatorDropdown;
